var header = document.querySelector('.header')
var topNav = document.querySelector('.top-nav')


document.addEventListener('scroll', function () {
    if (window.scrollY >= 40) {
        header.classList.add('header--scroll')
        topNav.classList.add('top-nav--hide')
    } else {
        header.classList.remove('header--scroll')
        topNav.classList.remove('top-nav--hide')
    }
});